import React, { useState, useEffect } from "react";
import { Page, Text, View, Document, Font, Image, StyleSheet, Svg } from "@react-pdf/renderer";
import { fontSize } from "@mui/system";
import { ReactComponent as HEcoA } from "../../../assets/ecoscore/eco_h_a.svg";

const items = [
  {
    category: "Catégorie d'impact",
    indicator: "Indicateur de catégorie d'impact",
    unit: "Unité",
    model: "Modèle de caractérisation",
  },
  {
    category: "Changement climatique",
    indicator: "Forçage radiatif exprimé en potentiel de réchauffement planétaire (PRP100)",
    unit: "kg CO2 eq",
    model: "Modèle de base sur 100 ans élaboré par le GIEC (basé sur GIEC 2013)",
  },
  {
    category: "Particules fines",
    indicator: "Impact sur la santé humaine",
    unit: "Incidences des maladies",
    model: "Méthode PM recommandée par PNUE (PNUE 2016)",
  },
  {
    category: "Épuisement des ressources en eau",
    indicator: "Potentiel de privation d'eau de l'utilisateur consommation d'eau pondérée en fonction de la privation)",
    unit: "m3 world eq",
    model: "Available WAter REmaining (AWARE) (eau disponible restante) tel que recommandé par PNUE, 2016",
  },
  {
    category: "Épuisement des ressources énergétiques",
    indicator: "Épuisement des ressources abiotiques - combustibles fossiles (ADP-riginefossile)",
    unit: "MJ",
    model: "CML 2002 (Guinée et al., 2002) et van Oers et al., 2002.",
  },
  {
    category: "Usage des terres",
    indicator: "- Indice de qualité du sol105\n- Production biotique\n- Résistance à l'érosion\n- Filtration mécanique\n- Recharge de la nappe phréatique",
    unit: "m3 world eq",
    model: "Available WAter REmaining (AWARE) (eau disponible restante) tel que recommandé par PNUE, 2016",
  },

  {
    category: "Épuisement des ressources - minéraux",
    indicator: "Épuisement des ressources abiotiques (dernièresréservesADP)",
    unit: "kg Sb eq",
    model: "CML 2002 (Guinée et al., 2002) et van Oers et al., 2002.",
  },
  {
    category: "Appauvrissement de la couche d'ozone",
    indicator: "Potentiel d'appauvrissement de la couche d'ozone(PACO)",
    unit: "kg CFC-11 eq",
    model: "PACO constants (OMM 2014 + intégrations)",
  },
  {
    category: "Acidification",
    indicator: "Accumulation d'excédents (AE)",
    unit: "mol H+ eq",
    model: "Accumulation d'excédents (Seppälä et al., 2006; Posch et al, 2008)",
  },
  {
    category: "Radiation ionisante, effet sur la santé",
    indicator: "PEfficacité de l'exposition humaine par rapport à U235otentiel",
    unit: "kBq U235 eq",
    model: "Modèle d'effets sur la santé humaine tel que développé par Dreicer et al., 1995 (Frischknecht et al., 2000)",
  },
  {
    category: "Formation photochimique d'ozone",
    indicator: "Augmentation de la concentration d'ozone de la troposphère",
    unit: "kg NMVOC eq",
    model: "Modèle LOTO-EUROS ( Van Zelm et al. 2008) tel qu'appliqué dans ReCiPe 2008",
  },
  {
    category: "Eutrophisation, terrestre",
    indicator: "Accumulation d'excédents (AE)",
    unit: "mol N eq",
    model: "Accumulation d'excédents (Seppälä et al., 2006; Posch et al, 2008)",
  },
  {
    category: "Eutrophisation, marine",
    indicator: "Fraction de nutriments atteignant le compartiment final marin (N)",
    unit: "kg N eq",
    model: "Modèle EUTREND (Struijs et al., 2009) tel qu'appliqué dans ReCiPe",
  },
  {
    category: "Eutrophisation, eau douce",
    indicator: "Fraction de nutriments atteignant le compartiment final des eauxdouces(P)",
    unit: "kg P eq",
    model: "Modèle EUTREND (Struijs et al., 2009) tel qu'appliqué dans ReCiPe",
  },
  {
    category: "Ecotoxicité d'eau douce",
    indicator: "Unité toxique comparative pour les écosystèmes (CTUe)",
    unit: "mol H+ eq",
    model: "Modèle USEtox 2.1 (Fankte et al., 2017)",
  },
  {
    category: "Toxicité humaine cancérigène",
    indicator: "Unité toxique comparative pour les êtres humains (CTUh)",
    unit: "CTUh",
    model: "Modèle USEtox 2.1 (Fankte et al., 2017)",
  },
  {
    category: "Toxicité humaine non-cancérigène",
    indicator: "Unité toxique comparative pour les êtres humains (CTUh)",
    unit: "CTUh",
    model: "Modèle USEtox 2.1 (Fankte et al., 2017)",
  },
];

// Create styles
const styles = StyleSheet.create({
  cover_page: {
    flexDirection: "row",
    backgroundColor: "white",
    // padding: 20,
    paddingHorizontal: 40,
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    // paddingRight: 80,
  },
  page: {
    flexDirection: "row",
    backgroundColor: "white",
    padding: 40,
    // paddingRight: 80,
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  results_container: {
    width: 200,
    flexDirection: "row",
    justifyContent: "center",
    // backgroundColor: "#318734",
    alignItems: "center",
    alignContent: "space-between",
  },

  summary_header: {
    fontSize: 18,
    fontWeight: "extrabold",
    fontFamily: "Helvetica-Bold",
  },
  summary_title: {
    fontWeight: "extrabold",
    fontSize: 11,
    fontFamily: "Helvetica-Bold",
  },
  summary_sub_title: {
    fontWeight: "light",
    fontSize: 11,
    fontFamily: "Helvetica",
  },

  paraph_title: {
    fontSize: 16,
    fontWeight: "bold",
    fontFamily: "Helvetica-Bold",
  },
  paraph_sub_title: {
    fontSize: 13,
  },
  paraph_sub_title_bold: {
    fontSize: 13,
    fontFamily: "Helvetica-Bold",
  },
  paraph_body: {
    fontSize: 11,
  },
  paraph_container_2: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    paddingRight: 60,
  },

  // TABLE HEADER
  table_row: {
    flexDirection: "row",
    alignItems: "center",
    // border: "1px solid black",
  },

  // IMPACT INDICATORS
  table_categorie: {
    width: "20%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },
  table_unit: {
    width: "10%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },
  table_indicateur: {
    width: "35%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },
  table_model: {
    width: "35%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },

  // ANALYSIS RESUME
  table_reference: {
    width: "20%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },
  table_product_name: {
    width: "20%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },
  table_type: {
    width: "20%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },
  table_eco_score: {
    width: "20%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },
  table_score_ef: {
    width: "20%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },

  // ANALYSIS INGREDIENTS
  table_row_ingredients: {
    flexDirection: "row",
    alignItems: "center",
    // border: "1px solid black",
  },
  table_step_ingredients: {
    width: "50%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },
  table_quantity_ingredients: {
    width: "10%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },
  // table_origin_ingredients: {
  //   width: "10%",
  //   height: "100%",
  //   fontSize: 11,
  //   border: "1px solid black",
  //   padding: 4,
  // },
  table_impact_ingredients: {
    width: "10%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },
  table_unique_score_ingredients: {
    width: "10%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },
  table_validate_ingredients: {
    width: "10%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },

  //  ANALYSIS RESULTS
  table_step: {
    width: "50%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },
  table_quantity: {
    width: "10%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },
  table_impact: {
    width: "10%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },
  table_unique_score: {
    width: "10%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },
  table_validate: {
    width: "10%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },

  //   viewer: {
  //     width: window.innerWidth,
  //     height: window.innerHeight,
  //   },
});

const get_eco_score_icon = (eco_score) => {
  switch (true) {
    case eco_score >= 80:
      return <Image style={{ width: 80, marginVertical: 15, marginHorizontal: 20 }} src={require("../../../assets/report/eco_A.png")} />;
    case eco_score <= 80 && eco_score >= 60:
      return <Image style={{ width: 80, marginVertical: 15, marginHorizontal: 20 }} src={require("../../../assets/report/eco_B.png")} />;
    case eco_score <= 60 && eco_score >= 40:
      return <Image style={{ width: 80, marginVertical: 15, marginHorizontal: 20 }} src={require("../../../assets/report/eco_C.png")} />;
    case eco_score <= 40 && eco_score >= 20:
      return <Image style={{ width: 80, marginVertical: 15, marginHorizontal: 20 }} src={require("../../../assets/report/eco_D.png")} />;
    case eco_score <= 20:
      return <Image style={{ width: 80, marginVertical: 15, marginHorizontal: 20 }} src={require("../../../assets/report/eco_E.png")} />;
    default:
      return;
  }
};

const get_eco_score_letter = (eco_score) => {
  switch (true) {
    case eco_score >= 80:
      return "A";
    case eco_score <= 80 && eco_score >= 60:
      return "B";
    case eco_score <= 60 && eco_score >= 40:
      return "C";
    case eco_score <= 40 && eco_score >= 20:
      return "D";
    case eco_score <= 20:
      return "E";
    default:
      return;
  }
};

// Create Document Component
const AnalysisReport = (props) => {
  const get_step_results_view = (idx) => {
    return (
      <>
        <View style={styles.table_row} key={"results_header"}>
          <Text style={styles.table_step}>{""}</Text>
          <Text style={styles.table_quantity}>{"Quantité"}</Text>
          <Text style={styles.table_quantity}>{"Catégorie"}</Text>
          <Text style={styles.table_impact}>{"% impact"}</Text>
          <Text style={styles.table_unique_score}>{"Score EF"}</Text>
          <Text style={styles.table_validate}>{"Validé à l'analyse"}</Text>
        </View>
        {props.analysis_steps_results &&
          props.analysis_steps_results[idx].data.map((y, i) => {
            return y.optimization_results ? (
              <>
                <View style={styles.table_row_ingredients} key={"transport_header" + i}>
                  <Text style={{ ...styles.table_step_ingredients, ...{ backgroundColor: "#CFEBE2" } }}>{"---" + y.custom_analysis.flow_name}</Text>
                  <Text style={{ ...styles.table_quantity_ingredients, ...{ backgroundColor: "#CFEBE2" } }}>{parseFloat(y.custom_analysis.quantity).toFixed(2) + " " + y.custom_analysis.unit}</Text>
                  <Text style={{ ...styles.table_quantity_ingredients, ...{ backgroundColor: "#CFEBE2" } }}>{y.custom_analysis.k_type}</Text>
                  <Text style={{ ...styles.table_impact_ingredients, ...{ backgroundColor: "#CFEBE2" } }}>{y.custom_analysis.percent_impact + "%"}</Text>
                  <Text style={{ ...styles.table_unique_score_ingredients, ...{ backgroundColor: "#CFEBE2" } }}>{parseFloat(y.custom_analysis.score_unique).toFixed(2) + " mPt"}</Text>
                  <Text style={{ ...styles.table_validate_ingredients, ...{ backgroundColor: "#CFEBE2" } }}>{y.custom_analysis.checked ? "Oui" : "Non"}</Text>
                </View>
                <View style={styles.table_row_ingredients} key={"transport_header" + i}>
                  <Text style={{ ...styles.table_step_ingredients, ...{ backgroundColor: "#FFF7E3" } }}>{"---" + y.optimization_results.flow_name}</Text>
                  <Text style={{ ...styles.table_quantity_ingredients, ...{ backgroundColor: "#FFF7E3" } }}>
                    {parseFloat(y.optimization_results.quantity).toFixed(2) + " " + y.optimization_results.unit}
                  </Text>
                  <Text style={{ ...styles.table_quantity_ingredients, ...{ backgroundColor: "#FFF7E3" } }}>{y.optimization_results.k_type}</Text>
                  <Text style={{ ...styles.table_impact_ingredients, ...{ backgroundColor: "#FFF7E3" } }}>{y.optimization_results.percent_impact + "%"}</Text>
                  <Text style={{ ...styles.table_unique_score_ingredients, ...{ backgroundColor: "#FFF7E3" } }}>{parseFloat(y.optimization_results.score_unique).toFixed(2) + " mPt"}</Text>
                  <Text style={{ ...styles.table_validate_ingredients, ...{ backgroundColor: "#FFF7E3" } }}>{y.optimization_results.checked ? "Oui" : "Non"}</Text>
                </View>
              </>
            ) : (
              <View style={styles.table_row_ingredients} key={"transport_header" + i}>
                <Text style={styles.table_step_ingredients}>{y.flow_name}</Text>
                <Text style={styles.table_quantity_ingredients}>{parseFloat(y.quantity).toFixed(2) + " " + y.unit}</Text>
                <Text style={styles.table_quantity_ingredients}>{y.k_type}</Text>
                <Text style={styles.table_impact_ingredients}>{y.percent_impact + "%"}</Text>
                <Text style={styles.table_unique_score_ingredients}>{parseFloat(y.score_unique).toFixed(2) + " mPt"}</Text>
                <Text style={styles.table_validate_ingredients}>{y.checked ? "Oui" : "Non"}</Text>
              </View>
            );
          })}
      </>
    );
  };
  return (
    <Document>
      <Page size="A4" style={styles.cover_page}>
        <View style={{ justifyContent: "center", alignItems: "center", alignContent: "center" }}>
          <Text style={{ fontSize: 28, fontWeight: "extrabold", fontFamily: "Helvetica" }}>Empreinte environnementale de produit</Text>
          {/* <Text style={{ fontSize: 42, fontWeight: "bold" }}>environnementale</Text>
          <Text style={{ fontSize: 42, fontWeight: "bold" }}>de produit</Text> */}
          <Text style={{ fontSize: 38, fontWeight: "extrabold", fontFamily: "Helvetica-Bold" }}>
            {"\n"}
            {"Rapport d'" + (props.is_optimization ? "optimisation" : "analyse")}
          </Text>
          <Text style={{ fontSize: 18, justifyContent: "center", alignItems: "center", alignContent: "center" }}>
            {"\n"}
            {"\n"}Nom du produit : {props.product_name}
            {"\n"}
            {"\n"}
          </Text>
          <View style={{ justifyContent: "center", alignItems: "center", alignContent: "center" }}>
            <Text style={{ fontSize: 18, fontWeight: "light" }}>Référence du produit :</Text>
            <Text style={{ fontSize: 18, fontWeight: "light" }}>
              {props.product_ref}
              {"\n"}
              {"\n"}
            </Text>
          </View>

          <Text style={{ fontSize: 18, fontWeight: "light" }}>
            Version : {"1.0.0"}
            {"\n"}
            {"\n"}
          </Text>
          <Text style={{ fontSize: 18, fontWeight: "light" }}>
            Valide pendant 8 mois{"\n"}
            {"\n"}
          </Text>
          <Text style={{ fontSize: 18, fontWeight: "light" }}>
            {"\n"}
            {"\n"}
            {"Résulats de l'" + (props.is_optimization ? "optimisation" : "analyse")} :{"\n"}
            {"\n"}
          </Text>
          <View style={styles.results_container}>
            {get_eco_score_icon(props.eco_score)}
            <View style={{ flexDirection: "row", justifyContent: "center", alignItems: "baseline" }}>
              <Text style={{ fontSize: 28, fontWeight: "extrabold", alignItems: "baseline" }}>{props.eco_score}</Text>
              <Text style={{ fontSize: 18, fontWeight: "light", alignItems: "baseline" }}>/100</Text>
            </View>
          </View>
          {/* <Text style={{ fontSize: 18 }}>
            {"\n"}
            {"\n"}Dénomination de l'entreprise: 
          </Text>
          <Text style={{ fontSize: 18 }}>Adresse:</Text> */}
        </View>
        {/* <View style={styles.section}>
        <Text>Section #2</Text>
      </View> */}
      </Page>

      <Page size="A4" style={styles.page}>
        <View style={{}}>
          <Text style={styles.summary_header}>Table des matières{"\n\n"}</Text>
          <Text style={styles.summary_title}>1. Introduction</Text>
          <Text style={styles.summary_title}>
            {"\n"}
            {"\n"}2. Sources de données
          </Text>
          <Text style={styles.summary_sub_title}>{"\n"}2.1. Agribalyse</Text>
          <Text style={styles.summary_sub_title}>{"\n"}2.1.1. Bases de données</Text>
          <Text style={styles.summary_sub_title}>{"\n"}2.1.2. Scénario de référence</Text>
          <Text style={styles.summary_sub_title}>{"\n"}2.2. Base IMPACTS</Text>
          <Text style={styles.summary_sub_title}>{"\n"}2.3. Éco-invent</Text>
          <Text style={styles.summary_sub_title}>{"\n"}2.4. World Food LCA</Text>
          <Text style={styles.summary_sub_title}>{"\n"}2.3. EF database</Text>
          <Text style={styles.summary_title}>
            {"\n"}
            {"\n"}3. Frontière du système
          </Text>
          <Text style={styles.summary_sub_title}>{"\n"}3.1. Étape de cycle de vie</Text>
          <Text style={styles.summary_sub_title}>{"\n"}3.2. Catégorie d'impact de l'EF</Text>
          <Text style={styles.summary_title}>
            {"\n"}
            {"\n"}4. Résultats de l'Analyse de Cycle de Vie
          </Text>
          <Text style={styles.summary_sub_title}>{"\n"}4.1. Résumé</Text>
          <Text style={styles.summary_sub_title}>{"\n"}4.2. Résultats par étape de cycle de vie</Text>
          <Text style={styles.summary_sub_title}>{"\n"}4.3. Indicateurs d'impacts</Text>
          <Text style={styles.summary_sub_title}>{"\n"}4.4. Interpétation des résultas de l'EF</Text>
        </View>
      </Page>

      <Page size="A4" style={styles.page}>
        <View style={{}}>
          <Text style={styles.paraph_title}>
            Acronymes{"\n"}
            {"\n"}
          </Text>
          <View style={{ flexDirection: "row" }}>
            <Text style={styles.paraph_sub_title_bold}>CE </Text>
            <Text style={styles.paraph_sub_title}>
              - Commission européenne {"\n"}
              {"\n"}
            </Text>
          </View>
          <View style={{ flexDirection: "row" }}>
            <Text style={styles.paraph_sub_title_bold}>EF </Text>
            <Text style={styles.paraph_sub_title}>
              - Empreinte environnementale (Environmental Footprint) {"\n"}
              {"\n"}
            </Text>
          </View>
          <View style={{ flexDirection: "row" }}>
            <Text style={styles.paraph_sub_title_bold}>IE </Text>
            <Text style={styles.paraph_sub_title}>
              - Impact environnemental {"\n"}
              {"\n"}
            </Text>
          </View>
          <View style={{ flexDirection: "row" }}>
            <Text style={styles.paraph_sub_title_bold}>ILCD </Text>
            <Text style={styles.paraph_sub_title}>
              - International Reference Life Cycle Data System (système international de référence pour les données sur le cycle vie) {"\n"}
              {"\n"}
            </Text>
          </View>
          <View style={{ flexDirection: "row" }}>
            <Text style={styles.paraph_sub_title_bold}>ACV </Text>
            <Text style={styles.paraph_sub_title}>
              - Analyse de Cycle de Vie {"\n"}
              {"\n"}
            </Text>
          </View>
          <View style={{ flexDirection: "row" }}>
            <Text style={styles.paraph_sub_title_bold}>ACVI </Text>
            <Text style={styles.paraph_sub_title}>
              - Évaluation de l'impact du cycle de vie {"\n"}
              {"\n"}
            </Text>
          </View>
          <View style={{ flexDirection: "row" }}>
            <Text style={styles.paraph_sub_title_bold}>PEF </Text>
            <Text style={styles.paraph_sub_title}>
              - Empreinte environnementale de produit (Product Environmental Footprint) {"\n"}
              {"\n"}
            </Text>
          </View>
        </View>
      </Page>

      <Page size="A4" style={styles.page}>
        <View style={{}}>
          <Text style={styles.paraph_title}>
            Définition{"\n"}
            {"\n"}
          </Text>
          <View style={{}}>
            <Text style={styles.paraph_sub_title_bold}>Méthode d'évaluation d'impact de l'empreinte environnementale (EF)</Text>
            <Text style={styles.paraph_sub_title}>
              - protocole permettant de transposer les données de l'inventaire du cycle de vie en contributions quantitatives à un impact environnemental considéré.{"\n"}
              {"\n"}
            </Text>
          </View>
          <View style={{}}>
            <Text style={styles.paraph_sub_title_bold}>Évaluation d'impact de l'empreinte environnementale (EF)</Text>
            <Text style={styles.paraph_sub_title}>
              - phase de l'analyse PEF qui vise à comprendre et à évaluer l'ampleur et l'importance des impacts potentiels d'un système de produits sur l'environnement au cours du cycle de vie du
              produit (d'après ISO 14044:2006). Les méthodes d'évaluation d'impact fournissent des facteurs de caractérisation de l'impact des flux élémentaires afin d'agréger les impacts pour obtenir
              un nombre limité d'indicateurs intermédiaire.{"\n"}
              {"\n"}
            </Text>
          </View>
          <View style={{}}>
            <Text style={styles.paraph_sub_title_bold}>Jeu de données conforme à la PEF</Text>
            <Text style={styles.paraph_sub_title}>
              {" "}
              - jeu de données établis conformément aux exigences en matière d'EF disponibles sur http://eplca.jrc.ec.europa.eu/LCDN/developer.xhtml.{"\n"}
              {"\n"}
            </Text>
          </View>
          <View style={{}}>
            <Text style={styles.paraph_sub_title_bold}>Indicateur de catégorie d'impact de l'empreinte environnementale (EF)</Text>
            <Text style={styles.paraph_sub_title}>
              {" "}
              - représentation quantifiable d'une catégorie d'impact de l'EF (d'après ISO 14000:2006).{"\n"}
              {"\n"}
            </Text>
          </View>
          <View style={{}}>
            <Text style={styles.paraph_sub_title_bold}>Impact environnemental</Text>
            <Text style={styles.paraph_sub_title}>
              - toute modification de l'environnement, qu'elle soit négative ou positive, entièrement ou partiellement provoquée par les activités, produits ou services d'une organisation (règlement
              EMAS).{"\n"}
              {"\n"}
            </Text>
          </View>
          <View style={{}}>
            <Text style={styles.paraph_sub_title_bold}>Cycle de vie</Text>
            <Text style={styles.paraph_sub_title}>
              - phases consécutives et liées d'un système de produits, de l'acquisition des matières premières ou de la génération des ressources naturelles à l'élimination finale (ISO 14040:2006).
              {"\n"}
              {"\n"}
            </Text>
          </View>
          <View style={{}}>
            <Text style={styles.paraph_sub_title_bold}>Analyse du cycle de vie (ACV)</Text>
            <Text style={styles.paraph_sub_title}>
              - compilation et évaluation des intrants, des extrants et des impacts environnementaux potentiels d'un système de produits au cours de son cycle de vie (ISO 14040:2006).{"\n"}
              {"\n"}
            </Text>
          </View>
          <View style={{}}>
            <Text style={styles.paraph_sub_title_bold}>Approche fondée sur le cycle de vie</Text>
            <Text style={styles.paraph_sub_title}>
              - approche qui prend en considération, sous l'angle de la chaîne d'approvisionnement, l'ensemble des flux de ressources et des interventions sur l'environnement associés à un produit, y
              compris tous les stades depuis l'acquisition des matières premières jusqu'aux processus en fin de vie en passant par la transformation, la distribution et l'utilisation, ainsi que tous
              les impacts environnementaux associés (au lieu de se concentrer sur un seul aspect).{"\n"}
              {"\n"}
            </Text>
          </View>
          <View style={{}}>
            <Text style={styles.paraph_sub_title_bold}>Étude PEF</Text>
            <Text style={styles.paraph_sub_title}>
              - terme employé pour identifier la totalité des actions nécessaires pour calculer les résultats de la PEF. Elle comprend la modélisation, la collecte des données et l'analyse des
              résultats. Elle exclut le rapport PEF et la vérification de l'étude et du rapport PEF.{"\n"}
              {"\n"}
            </Text>
          </View>
          <View style={{}}>
            <Text style={styles.paraph_sub_title_bold}>Déchets</Text>
            <Text style={styles.paraph_sub_title}>
              {" "}
              - substances ou objets que le détenteur a l'intention d'éliminer ou qu'il est tenu d'éliminer (ISO 14040:2006).{"\n"}
              {"\n"}
            </Text>
          </View>
        </View>
      </Page>

      <Page size="A4" style={styles.page}>
        <View style={{}}>
          <Text style={styles.paraph_title}>1. Introduction</Text>
          <Text style={styles.paraph_body}>
            {"\n"}L'empreinte environnementale du produit (PEF) est une mesure multicritère de la performance environnementale des biens et services dans une perspective de cycle de vie. Les études
            PEF sont produites dans le but général de chercher à réduire les impacts environnementaux associés aux biens et services, en tenant compte des activités de la chaîne d'approvisionnement
            (de l'extraction des matières premières, en passant par la production et l'utilisation, jusqu'à la gestion des déchets finaux).
            {"\n"}
            {"\n"}Ce document rapporte les méthodes et résultats de l'étude menée avec le logiciel Lokalité, du produit "{props.product_name}" de référence {props.product_ref}. La démarche de Lokalité
            consiste en deux étapes accélératrice de l'analyse :{"\n"}
            {"\n"}- Choisir une analyse de cycle de vie de référence (d'un produit type), issue de la base de donnée Agribalyse décrite ci-dessous.
            {"\n"}- Ajuster les informations de cycle de vie afin de se rapprocher de son produit en particulier.
            {"\n"}
            {"\n"}L'analyse présenté ici est basé sur la méthodologie PEF, une approche fondée sur l'Analyse de Cycle de Vie, initiée et publiée par la Commission européenne.
            {"\n"}
            {"\n"}
          </Text>

          <Text style={styles.paraph_title}>
            {"\n"}
            {"\n"}2. Sources de données
          </Text>
          <Text style={styles.paraph_body}>
            {"\n"}Pour l'étude suivante, les jeux de données agrégés sont conformes à l'EF à la disposition de la Commission européenne, selon les exigences en matière d'EF disponibles à l'adresse
            http://eplca.jrc.ec.europa.eu/LCDN/developer.xhtml.{"\n"}
            {"\n"}
          </Text>

          <Text style={styles.paraph_sub_title_bold}>2.1. Agribalyse</Text>
          <Text style={styles.paraph_sub_title}>
            {"\n"}2.1.1 Base de données{"\n"}
          </Text>
          <View style={styles.paraph_container_2}>
            <Image style={{ width: 40, marginVertical: 15, marginHorizontal: 20 }} src={require("../../../assets/report/agribalyse.png")} />
            <Text style={styles.paraph_body}>
              Le programme AGRIBALYSE® fournit une base de données et un dispositif de référence pour l'analyse environnementale des produits alimentaires. Les données sont fondées sur la méthode de
              l'Analyse du Cycle de Vie (ACV). Cette méthode fournit des indicateurs d'impacts environnementaux des produits, incluant toutes les étapes intervenant dans la fabrication des produits
              (du champ à l'assiette) et prenant en compte différents enjeux environnementaux (climat, eau, air, sol…).
            </Text>
          </View>

          <Text style={styles.paraph_sub_title}>{"\n"}2.1.2 Scénario de référence</Text>
          <Text style={styles.paraph_body}>
            {"\n"}Le programme AGRIBALYSE® est une base de données publiques comprenant des données de référence pour 2500 produits alimentaires et 200 produits agricoles bruts. C'est un dispositif
            méthodologique de référence pour l'analyse environnementale des produits agricoles et alimentaires.
          </Text>

          <Text style={styles.paraph_sub_title_bold}>{"\n"}2.2. Base IMPACTS</Text>
          <View style={styles.paraph_container_2}>
            <Image style={{ width: 40, marginVertical: 15, marginHorizontal: 20 }} src={require("../../../assets/report/base_impacts.png")} />
            <Text style={styles.paraph_body}>
              {"\n"}Base de données génériques d'inventaires de cycles de vie, source d'information officielle pour le programme gouvernemental français d'affichage environnemental des produits de
              grande consommation.
            </Text>
          </View>
        </View>
      </Page>

      <Page size="A4" style={styles.page}>
        <View style={{}}>
          <Text style={styles.paraph_sub_title_bold}>{"\n"}2.3. Éco-invent</Text>
          <View style={styles.paraph_container_2}>
            <Image style={{ width: 40, marginVertical: 15, marginHorizontal: 20 }} src={require("../../../assets/report/ecoinvent.png")} />
            <Text style={styles.paraph_body}>
              {"\n"}Base de données multisectorielle et internationale, employées pour la réalisation des ACV, des déclarations environnementales de produits EPD, des bilans CO2, de la politique
              intégrée des produits, du management de cycle de vie, du design environnemental, de la certification environnementale et d'autre applications.
            </Text>
          </View>

          <Text style={styles.paraph_sub_title_bold}>{"\n"}2.2. World Food LCA</Text>
          <View style={styles.paraph_container_2}>
            <Image style={{ width: 40, marginVertical: 15, marginHorizontal: 20 }} src={require("../../../assets/report/wflca.png")} />
            <Text style={styles.paraph_body}>
              {"\n"}Base de données d'ACV de produits alimentaires à l'échelle internationale (développée par Quantis, soutenue par de grands entreprises agroalimentaires internationales).
            </Text>
          </View>

          <Text style={styles.paraph_sub_title_bold}>{"\n"}2.2. EF database</Text>
          <View style={styles.paraph_container_2}>
            <Image style={{ width: 40, marginVertical: 15, marginHorizontal: 20 }} src={require("../../../assets/report/ce.png")} />
            <Text style={styles.paraph_body}>
              {"\n"}La base de données de l'empreinte environnementale (EF) est conçue pour prendre en charge l'utilisation des règles de catégorie d'empreinte environnementale de produit (PEFCR) et
              des règles sectorielles d'empreinte environnementale d'organisation (OEFSR). Il contient des ensembles de données secondaires d'inventaire du cycle de vie conformes à l'EF et une méthode
              d'évaluation de l'impact de l'EF compatible. La base de données sur l'empreinte environnementale fait partie de l'initiative du marché unique des produits verts de la Commission
              européenne.
            </Text>
          </View>

          <Text style={styles.paraph_title}>
            {"\n"}
            {"\n"}3. Frontière du système
          </Text>
          <Text style={styles.paraph_sub_title_bold}>{"\n"}3.1. Étape de cycle de vie</Text>
          <Text style={styles.paraph_body}>{"\n"}Par défaut, les étapes de cycle de vie considérées lors de cette étude :</Text>
          <Text style={styles.paraph_sub_title_bold}>{"\n"}Recette</Text>
          <Text style={styles.paraph_body}>
            {"\n"}L'étape de recette décrit la phase de fabrication du produit. Les activités liées à la production comprennent :{"\n"}
            {"\n"}- Origine des ingrédients.
            {"\n"}- Transport des ingrédients jusqu'à l'usine de transformation.
            {"\n"}- Processus de fabrication.
            {"\n"}
            {"\n"}Les déchets des produits utilisés lors de la fabrication ne sont pas inclus dans la modélisation de l'étape de recette.
          </Text>
        </View>
      </Page>

      <Page size="A4" style={styles.page}>
        <View style={{}}>
          <Text style={styles.paraph_sub_title_bold}>{"\n"}Packaging</Text>
          <Text style={styles.paraph_body}>
            {"\n"}La production et la fin de vie des emballages est prise en compte. Dans cette étape, uniquement la phase d'emballage des produits transformés et leurs transports est considérée. La
            fin de vie est reprise à l'étape de la consommation. Le périmètre géographique utilisé pour la production des emballages est mondial (principalement des jeux de données européens) et
            français pour la fin de vie des emballages.
            {"\n"}
            {"\n"}-Par souci de simplification, nous avons fait l'hypothèse que les fruits ne sont pas emballés
            {"\n"}-Dans le cas d'un emballage composé, seul l'emballage le plus lourd est pris en compte (par exemple : pour des céréales, le sachet plastique intérieur n'est pas pris en compte, le
            seul matériau d'emballage considéré pour les céréales est la boîte en carton).
            {"\n"}
            {"\n"}Dans cette étape est considéré :{"\n"}
            {"\n"}- Le type de matériaux d'emballage utilisé.
            {"\n"}- Le transport mis en œuvre pour acheminer le produit emballé à l'étape suivante.
          </Text>

          <Text style={styles.paraph_sub_title_bold}>{"\n"}Distribution</Text>
          <Text style={styles.paraph_body}>
            {"\n"}Les produits sont distribués aux utilisateurs et peuvent être entreposés en divers points de la chaîne d'approvisionnement. L'étape de distribution inclut :{"\n"}
            {"\n"}- Le transport au point de vente de détail
            {"\n"}- Le stockage à l'entrepôt (besoin énergétique…)
          </Text>

          <Text style={styles.paraph_sub_title_bold}>{"\n"}Vente au détail</Text>
          <Text style={styles.paraph_body}>
            {"\n"}Cette étape correspond à la vente en supermarché et est modélisée principalement en se basant sur les données par défaut du PEF, tirées du document d'orientation du PEF (European
            Commission, 2016). Elle inclut :{"\n"}
            {"\n"}- Transport au centre de vente
            {"\n"}- Le stockage au point de vente de détail (besoin énergétique…)
            {"\n"}- Déchet et revalorisation
          </Text>

          <Text style={styles.paraph_sub_title_bold}>{"\n"}Consommation</Text>
          <Text style={styles.paraph_body}>
            {"\n"}L'étape d'utilisation décrit l'utilisation escomptée du produit par l'utilisateur final (le consommateur, par exemple). L'étape d'utilisation commence lorsque l'utilisateur final
            utilise le produit et s'achève lorsque ce dernier quitte son lieu d'utilisation et entre dans l'étape de fin de vie (EoL) (par ex., recyclage ou traitement final). Le transport vers les
            installations de traitement en fin de vie est exclu de l'étape d'utilisation et fait partie de l'étape de fin de vie. L'étape d'utilisation comprend toutes les activités et tous les
            produits nécessaires à la bonne utilisation du produit (à savoir, le maintien de la fonction d'origine tout au long de sa durée de vie). Les déchets du produit en cours d'utilisation, tels
            que les déchets alimentaires et l'emballage primaire ou ce qu'il reste du produit lorsqu'il n'est plus utilisé, sont exclus de l'étape d'utilisation et doivent faire partie de l'étape de
            fin de vie du produit.
          </Text>
        </View>
      </Page>

      {/* IMPACT INDICATORS */}
      <Page size="A4" style={styles.page}>
        <View style={{}}>
          <Text style={styles.paraph_sub_title_bold}>
            3.2. Catégories d'impact de l'EF{"\n"}
            {"\n"}
          </Text>
          {items.slice(0, 14).map((item, i) => (
            <View style={styles.table_row} key={i}>
              <Text style={styles.table_categorie}>{item.category}</Text>
              <Text style={styles.table_indicateur}>{item.indicator}</Text>
              <Text style={styles.table_unit}>{item.unit}</Text>
              <Text style={styles.table_model}>{item.model}</Text>
            </View>
          ))}
        </View>
      </Page>

      {/*  STEPS RESULTS */}
      <Page size="A4" style={styles.page}>
        <View style={{}}>
          {items.slice(14, 16).map((item, i) => (
            <View style={styles.table_row} key={i}>
              <Text style={styles.table_categorie}>{item.category}</Text>
              <Text style={styles.table_indicateur}>{item.indicator}</Text>
              <Text style={styles.table_unit}>{item.unit}</Text>
              <Text style={styles.table_model}>{item.model}</Text>
            </View>
          ))}

          <Text style={styles.paraph_title}>
            {"\n"}
            {"\n"}4. Résultats de l'Analyse de Cycle de Vie
          </Text>
          <Text style={styles.paraph_sub_title_bold}>
            {"\n"}4.1. Résumé{"\n"}
            {"\n"}
          </Text>

          <View style={styles.table_row} key={"results_resume_header"}>
            <Text style={styles.table_reference}>{"Référence"}</Text>
            <Text style={styles.table_product_name}>{"Nom du produit"}</Text>
            <Text style={styles.table_type}>{"Type"}</Text>
            <Text style={styles.table_score_ef}>{"Éco-score"}</Text>
            <Text style={styles.table_eco_score}>{"Score EF"}</Text>
          </View>

          <View style={styles.table_row} key={"results_resume_body"}>
            <Text style={styles.table_reference}>
              {props.product_ref.slice(0, 17) +
                "\n" +
                (props.product_ref.length - 17 > 0
                  ? props.product_ref.slice(17, props.product_ref.length - 17) + "\n" + props.product_ref.slice(props.product_ref.length - 17, props.product_ref.length)
                  : props.product_ref.slice(17, props.product_ref.length))}
            </Text>
            <Text style={styles.table_product_name}>{props.product_name}</Text>
            <Text style={styles.table_type}>{"Analyse"}</Text>
            <Text style={styles.table_score_ef}>{get_eco_score_letter(props.eco_score)}</Text>
            <Text style={styles.table_eco_score}>{props.eco_score + "/100"}</Text>
          </View>

          <Text style={styles.paraph_sub_title_bold}>
            {"\n"}
            {"\n"}4.2. Résultats par étape de cycle de vie{"\n"}
            {"\n"}
          </Text>

          <Text style={styles.paraph_sub_title}>
            4.2.1. Recette{"\n"}
            {"\n"}
          </Text>

          <View style={styles.table_row_ingredients} key={"results_header"}>
            <Text style={styles.table_step_ingredients}>{""}</Text>
            <Text style={styles.table_quantity_ingredients}>{"Quantité"}</Text>
            {/* <Text style={styles.table_origin_ingredients}>{"Origine"}</Text> */}
            <Text style={styles.table_quantity_ingredients}>{"Catégorie"}</Text>
            <Text style={styles.table_impact_ingredients}>{"% impact"}</Text>
            <Text style={styles.table_unique_score_ingredients}>{"Score EF"}</Text>
            <Text style={styles.table_validate_ingredients}>{"Validé à l'analyse"}</Text>
          </View>
          {props.analysis_steps_results &&
            props.analysis_steps_results[4].data.map((x, i) => (
              <>
                <View style={styles.table_row_ingredients} key={"results_header" + i}>
                  <Text style={styles.table_step_ingredients}>{x.flow_name}</Text>
                  <Text style={styles.table_quantity_ingredients}>{parseFloat(x.quantity).toFixed(2) + " " + x.unit}</Text>
                  {/* <Text style={styles.table_origin_ingredients}>{"-"}</Text> */}
                  <Text style={styles.table_quantity_ingredients}>{x.k_type}</Text>
                  <Text style={styles.table_impact_ingredients}>{x.percent_impact + "%"}</Text>
                  <Text style={styles.table_unique_score_ingredients}>{parseFloat(x.score_unique).toFixed(2) + " mPt"}</Text>
                  <Text style={styles.table_validate_ingredients}>{x.checked ? "Oui" : "Non"}</Text>
                </View>

                {/* ORIGINS */}
                <View style={styles.table_row_ingredients} key={"origin_header_t" + i}>
                  <Text style={styles.table_step_ingredients}>{"--- Origine(s)"}</Text>
                  <Text style={styles.table_quantity_ingredients}>{""}</Text>
                  {/* <Text style={styles.table_origin_ingredients}>{""}</Text> */}
                  <Text style={styles.table_quantity_ingredients}>{""}</Text>
                  <Text style={styles.table_impact_ingredients}>{""}</Text>
                  <Text style={styles.table_unique_score_ingredients}>{""}</Text>
                  <Text style={styles.table_validate_ingredients}>{""}</Text>
                </View>
                {x.origins ? (
                  x.origins.map((y) => (
                    <View style={styles.table_row_ingredients} key={"origin_header_b" + i}>
                      <Text style={styles.table_step_ingredients}>{"------ " + Object.keys(y)[0]}</Text>
                      <Text style={styles.table_quantity_ingredients}>{Object.values(y)[0].toFixed(2) + "%"}</Text>
                      {/* <Text style={styles.table_origin_ingredients}>{Object.values(y)[0]}</Text> */}
                      <Text style={styles.table_quantity_ingredients}>{"-"}</Text>
                      <Text style={styles.table_impact_ingredients}>{"-"}</Text>
                      <Text style={styles.table_unique_score_ingredients}>{"-"}</Text>
                      <Text style={styles.table_validate_ingredients}>{"-"}</Text>
                    </View>
                  ))
                ) : (
                  <View style={styles.table_row_ingredients} key={"origin_header_f" + i}>
                    <Text style={styles.table_step_ingredients}>{"------ Pas d'origines indiquées."}</Text>
                    <Text style={styles.table_quantity_ingredients}>{""}</Text>
                    {/* <Text style={styles.table_origin_ingredients}>{""}</Text> */}
                    <Text style={styles.table_quantity_ingredients}>{""}</Text>
                    <Text style={styles.table_impact_ingredients}>{""}</Text>
                    <Text style={styles.table_unique_score_ingredients}>{""}</Text>
                    <Text style={styles.table_validate_ingredients}>{""}</Text>
                  </View>
                )}

                {/* TRANSPORTS */}
                <View style={styles.table_row_ingredients} key={"origin_header" + i}>
                  <Text style={styles.table_step_ingredients}>{"--- Transport(s)"}</Text>
                  <Text style={styles.table_quantity_ingredients}>{""}</Text>
                  {/* <Text style={styles.table_origin_ingredients}>{""}</Text> */}
                  <Text style={styles.table_quantity_ingredients}>{""}</Text>
                  <Text style={styles.table_impact_ingredients}>{""}</Text>
                  <Text style={styles.table_unique_score_ingredients}>{""}</Text>
                  <Text style={styles.table_validate_ingredients}>{""}</Text>
                </View>
                {x.transports ? (
                  x.transports.map((y) => {
                    return y.optimization_results ? (
                      <>
                        <View style={styles.table_row_ingredients} key={"transport_header" + i}>
                          <Text style={{ ...styles.table_step_ingredients, ...{ backgroundColor: "#CFEBE2" } }}>{"---------" + y.custom_analysis.flow_name}</Text>
                          <Text style={{ ...styles.table_quantity_ingredients, ...{ backgroundColor: "#CFEBE2" } }}>
                            {parseFloat(y.custom_analysis.quantity).toFixed(2) + " " + y.custom_analysis.unit}
                          </Text>
                          <Text style={{ ...styles.table_quantity_ingredients, ...{ backgroundColor: "#CFEBE2" } }}>{y.custom_analysis.k_type}</Text>
                          <Text style={{ ...styles.table_impact_ingredients, ...{ backgroundColor: "#CFEBE2" } }}>{y.custom_analysis.percent_impact + "%"}</Text>
                          <Text style={{ ...styles.table_unique_score_ingredients, ...{ backgroundColor: "#CFEBE2" } }}>{parseFloat(y.custom_analysis.score_unique).toFixed(2) + " mPt"}</Text>
                          <Text style={{ ...styles.table_validate_ingredients, ...{ backgroundColor: "#CFEBE2" } }}>{y.custom_analysis.checked ? "Oui" : "Non"}</Text>
                        </View>
                        <View style={styles.table_row_ingredients} key={"transport_header" + i}>
                          <Text style={{ ...styles.table_step_ingredients, ...{ backgroundColor: "#FFF7E3" } }}>{"---------" + y.optimization_results.flow_name}</Text>
                          <Text style={{ ...styles.table_quantity_ingredients, ...{ backgroundColor: "#FFF7E3" } }}>
                            {parseFloat(y.optimization_results.quantity).toFixed(2) + " " + y.optimization_results.unit}
                          </Text>
                          <Text style={{ ...styles.table_quantity_ingredients, ...{ backgroundColor: "#FFF7E3" } }}>{y.optimization_results.k_type}</Text>
                          <Text style={{ ...styles.table_impact_ingredients, ...{ backgroundColor: "#FFF7E3" } }}>{y.optimization_results.percent_impact + "%"}</Text>
                          <Text style={{ ...styles.table_unique_score_ingredients, ...{ backgroundColor: "#FFF7E3" } }}>{parseFloat(y.optimization_results.score_unique).toFixed(2) + " mPt"}</Text>
                          <Text style={{ ...styles.table_validate_ingredients, ...{ backgroundColor: "#FFF7E3" } }}>{y.optimization_results.checked ? "Oui" : "Non"}</Text>
                        </View>
                      </>
                    ) : (
                      <View style={styles.table_row_ingredients} key={"transport_header" + i}>
                        <Text style={styles.table_step_ingredients}>{"------" + y.flow_name}</Text>
                        <Text style={styles.table_quantity_ingredients}>{parseFloat(y.quantity).toFixed(2) + " " + y.unit}</Text>
                        <Text style={styles.table_quantity_ingredients}>{y.k_type}</Text>
                        <Text style={styles.table_impact_ingredients}>{y.percent_impact + "%"}</Text>
                        <Text style={styles.table_unique_score_ingredients}>{parseFloat(y.score_unique).toFixed(2) + " mPt"}</Text>
                        <Text style={styles.table_validate_ingredients}>{y.checked ? "Oui" : "Non"}</Text>
                      </View>
                    );
                  })
                ) : (
                  <View style={styles.table_row_ingredients} key={"transport_header" + i}>
                    <Text style={styles.table_step_ingredients}>{"------ Pas de transports indiqués."}</Text>
                    <Text style={styles.table_quantity_ingredients}>{""}</Text>
                    <Text style={styles.table_quantity_ingredients}>{""}</Text>
                    <Text style={styles.table_impact_ingredients}>{""}</Text>
                    <Text style={styles.table_unique_score_ingredients}>{""}</Text>
                    <Text style={styles.table_validate_ingredients}>{""}</Text>
                  </View>
                )}
              </>
            ))}

          <Text style={styles.paraph_sub_title}>
            {"\n"}
            {"\n"}4.2.2. Packaging{"\n"}
            {"\n"}
          </Text>

          {get_step_results_view(3)}

          <Text style={styles.paraph_sub_title}>
            {"\n"}
            {"\n"}4.2.3. Distribution{"\n"}
            {"\n"}
          </Text>
          {get_step_results_view(2)}

          <Text style={styles.paraph_sub_title}>
            {"\n"}
            {"\n"}4.2.4. Vente au détail{"\n"}
            {"\n"}
          </Text>
          {get_step_results_view(1)}

          <Text style={styles.paraph_sub_title}>
            {"\n"}
            {"\n"}4.2.5. Consommation{"\n"}
            {"\n"}
          </Text>
          {get_step_results_view(0)}
        </View>
      </Page>

      {/* REFERENCE */}
      <Page size="A4" style={styles.page}>
        <View style={{}}>
          <Text style={styles.paraph_title}>
            5. Références{"\n"}
            {"\n"}
          </Text>

          <Text style={styles.paraph_sub_title}>
            [1] https://doc.agribalyse.fr/documentation/
            {"\n"}
            {"\n"}
          </Text>
          <Text style={styles.paraph_sub_title}>
            [2] https://base-impacts.ademe.fr/
            {"\n"}
            {"\n"}
          </Text>
          <Text style={styles.paraph_sub_title}>
            [3] https://ecoinvent.org/the-ecoinvent-database/
            {"\n"}
            {"\n"}
          </Text>
          <Text style={styles.paraph_sub_title}>
            [4] https://eplca.jrc.ec.europa.eu/EnvironmentalFootprint.html
            {"\n"}
            {"\n"}
          </Text>
          <Text style={styles.paraph_sub_title}>
            [5] https://docs.score-environnemental.com/
            {"\n"}
            {"\n"}
          </Text>
        </View>
      </Page>
    </Document>
  );
};
export default AnalysisReport;
